
/**
 * Module dependencies.
 */

import { Card, CardProps } from './card';
import { color } from 'react-components/styles';
import { ifProp } from 'styled-tools';
import { typography } from './typography/typography-styles';
import styled, { css } from 'styled-components';

/**
 * Export `Table` styled component.
 */

export const Table = styled.div.attrs({ role: 'table' })`
  width: 100%;
`;

/**
 * Export `Cell` styled component.
 */

export const Cell = styled.span.attrs<{ head?: boolean }>(({ head }) => ({ role: head ? 'columnheader' : 'cell' }))`
  ${typography.styles.textSmall}

  ${ifProp('head', css`
    color: ${color('gray500')};
  `)}
`;

/**
 * `Props` type.
 */

type Props = CardProps & {
  rowIndex?: number;
};

/**
 * Export `Row` component.
 */

export function Row(props: Props): JSX.Element {
  const { children, className, rowIndex, ...rest } = props;

  return (
    <Card
      {...rest}
      aria-rowindex={rowIndex}
      className={className}
      role={'row'}
    >
      {children}
    </Card>
  );
}
